import React from "react"
import withAnalyticsContext from '../../lib/hocs/withAnalyticsContext';


class FrequentlyAskedQuestion extends React.Component {
  faqClick = content => (
    () => {
      this.props.analytics.logEvent('shop_faq_clicked', { 'content': content });
    }
  );

  render() {
    return (
      <div className="frequently-asked-question">
        <div className="container">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2">よくある質問</h2>
          </div>
          <div>
            <div data-aos="fade-up" className="columns">
              <div className="column">
                <a
                  className="button is-size-normal-large is-primary is-inverted is-fullwidth is-rounded is-bordered is-arrow"
                  href="https://picksrestaurant.zendesk.com/hc/ja/articles/360042211314-%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E5%88%A9%E7%94%A8%E6%89%8B%E6%95%B0%E6%96%99%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
                  onClick={this.faqClick('fee')}
                >
                  手数料は<br/>いくらかかりますか？
                </a>
              </div>
              <div className="column">
                <a
                  className="button is-size-normal-large is-primary is-inverted is-fullwidth is-rounded is-bordered is-arrow"
                  href="https://picksrestaurant.zendesk.com/hc/ja/articles/360042211354-%E5%A3%B2%E4%B8%8A%E3%81%AE%E5%85%A5%E9%87%91%E3%82%B5%E3%82%A4%E3%82%AF%E3%83%AB%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
                  onClick={this.faqClick('payment')}
                >
                  売上の振込サイクルは？
                </a>
              </div>
            </div>
            <div data-aos="fade-up" className="columns">
              <div className="column">
                <a
                  className="button is-size-normal-large is-primary is-inverted is-fullwidth is-rounded is-bordered is-arrow"
                  href="https://picksrestaurant.zendesk.com/hc/ja/articles/360042701413-%E5%AF%BE%E5%BF%9C%E7%AB%AF%E6%9C%AB%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
                  onClick={this.faqClick('device')}
                >
                  対応している端末は？
                </a>
              </div>
              <div className="column">
                <a
                  className="button is-size-normal-large is-primary is-inverted is-fullwidth is-rounded is-bordered is-arrow"
                  href="https://picksrestaurant.zendesk.com/hc/ja/articles/360042211394-%E6%9C%80%E4%BD%8E%E6%B3%A8%E6%96%87%E6%99%82%E9%96%93%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
                  onClick={this.faqClick('min_order_time')}
                >
                  最低注文時間の設定は<br/>できますか？
                </a>
              </div>
            </div>
            <div data-aos="fade-up" className="columns">
              <div className="column">
                <a
                  className="button is-size-normal-large is-primary is-inverted is-fullwidth is-rounded is-bordered is-arrow"
                  href="https://picksrestaurant.zendesk.com/hc/ja/articles/360042701433-%E6%B3%A8%E6%96%87%E3%82%AD%E3%83%A3%E3%83%B3%E3%82%BB%E3%83%AB%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
                  onClick={this.faqClick('cancel')}
                >
                  突然のキャンセルは<br/>どうしたらいいですか？
                </a>
              </div>
              <div className="column">
                <a
                  className="button is-size-normal-large is-primary is-inverted is-fullwidth is-rounded is-bordered is-arrow"
                  href="https://picksrestaurant.zendesk.com/hc/ja/articles/360042211414-%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%E3%81%AE%E6%94%AF%E6%89%95%E3%81%84%E6%96%B9%E6%B3%95%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
                  onClick={this.faqClick('cash')}
                >
                  お客様の現金でも<br/>支払いはできますか？
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withAnalyticsContext(FrequentlyAskedQuestion)
